import { Component, OnDestroy, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { setTheme } from 'ngx-bootstrap/utils';
import { StateService } from '@uirouter/angular';
import { Subscription } from 'rxjs';
import { AlertAndNotificationsService } from './core/services/alert-and-notifications.service';
import { AuthService } from './core/services/auth.service';
import { AngularModalService } from './core/services/modal.service';
import { MeetingService } from './core/services/meeting.service';
import { ShellService } from './core/services/shell.service';
import { StorageService } from './core/services/storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent implements OnInit, OnDestroy {
  title = '4dot5 Mission Control';
  private logoutFromMeetingSubscription: Subscription;

  constructor(
    private $state: StateService,
    private authService: AuthService,
    private meetingService: MeetingService,
    private shellService: ShellService,
    private storageService: StorageService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    // injected only so the service is created at startup and its modal-open handling is active
    private angularModalService: AngularModalService
  ) {
    // For ngx-bootstrap
    setTheme('bs3');
  }

  get userActive(): boolean {
    return this.authService.isUserActive;
  }

  get showHeaderNav(): boolean {
    return this.shellService.showHeaderNav;
  }

  ngOnInit() {
    this.logoutFromMeetingSubscription = this.meetingService.logoutFromMeeting.subscribe(() => {
      this.authService.setUserActive(false);
      this.shellService.showHeaderNav = true;
      setTimeout(() => this._logoutAndRedirectUser(), 1000);
    });
  }

  ngOnDestroy() {
    if (this.logoutFromMeetingSubscription) {
      this.logoutFromMeetingSubscription.unsubscribe();
    }
  }

  private _logoutAndRedirectUser() {
    const rememberMeStatus = _.cloneDeep(this.storageService.getCookie('rememberme'));
    const userDetails = _.cloneDeep(this.storageService.get('userDetails'));
    this.storageService.resetBrowserStorage();
    if (rememberMeStatus === true && userDetails !== undefined && userDetails !== null) {
      this.storageService.setCookie('logoutemail', userDetails.emailId, undefined);
    }
    this.authService.logout(() => {
      this.storageService.removeCookie('connect.sid', undefined);
      this.storageService.remove('companyDetails');
      this.storageService.remove('SelectedHostCompany');
      this.storageService.remove('userDetails');
      this.$state.go('exitMeeting', null, { reload: true });
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }
}
